/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataAdvertisersQueryResponse, AuditReportsGetGipMetadataAdvertisersQueryParams, AuditReportsGetGipMetadataAdvertisers401, AuditReportsGetGipMetadataAdvertisers403 } from "../models/AuditReportsGetGipMetadataAdvertisers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipMetadataAdvertisers } from "../axios/auditReportsGetGipMetadataAdvertisers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipMetadataAdvertisersQueryKey = (params: AuditReportsGetGipMetadataAdvertisersQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/reports/gip/metadata/advertisers' }, ...(params ? [params] : [])] as const

export type AuditReportsGetGipMetadataAdvertisersQueryKey = ReturnType<typeof auditReportsGetGipMetadataAdvertisersQueryKey>

export function auditReportsGetGipMetadataAdvertisersQueryOptions(params?: AuditReportsGetGipMetadataAdvertisersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipMetadataAdvertisersQueryKey(params)
        return queryOptions<AuditReportsGetGipMetadataAdvertisersQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataAdvertisers401 | AuditReportsGetGipMetadataAdvertisers403>, AuditReportsGetGipMetadataAdvertisersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipMetadataAdvertisers(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Return cached GIP advertisers for the client
 * {@link /audit-reports/v1/reports/gip/metadata/advertisers}
 */
export function useAuditReportsGetGipMetadataAdvertisers<TData = AuditReportsGetGipMetadataAdvertisersQueryResponse, TQueryData = AuditReportsGetGipMetadataAdvertisersQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipMetadataAdvertisersQueryKey>(params?: AuditReportsGetGipMetadataAdvertisersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipMetadataAdvertisersQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataAdvertisers401 | AuditReportsGetGipMetadataAdvertisers403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipMetadataAdvertisersQueryKey(params)
         

         const query = useQuery({
          ...auditReportsGetGipMetadataAdvertisersQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipMetadataAdvertisers401 | AuditReportsGetGipMetadataAdvertisers403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}